import { CustomerResponse } from './types';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';

class LogisticsClient {
  getCustomer(customerId: number) {
    return new Promise<CustomerResponse>((resolve, reject) => {
      loopBackApi()
        .get(`customers/get-by-id/${customerId}`)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err.message));
    });
  }
}

const logisticsClient = new LogisticsClient();

export { logisticsClient };
